// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__VarJE","select":"Header_select__2sNSn","clinic":"Header_clinic__1FvTf"};